module.exports = __webpack_public_path__ + "static/media/visa.c906a3da.svg";